var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle, accessibilityCompliant: true } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("div", { staticClass: "mb-4" }, [
                        _c("p", { staticClass: "text-muted" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("sitemap.description")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.menuSections, function (section) {
                        return _c(
                          "div",
                          { key: section.title, staticClass: "mb-4" },
                          [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "h5 font-weight-bold text-menu mb-3",
                                staticStyle: { color: "#495057" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(section.title)) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            section.pages && section.pages.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "pl-3" },
                                  _vm._l(section.pages, function (page) {
                                    return _c(
                                      "div",
                                      {
                                        key: page.id || page.title,
                                        staticClass: "mb-1",
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item-web-header mb-1 text-decoration-none d-block p-2 rounded",
                                            attrs: { href: page.link },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.navigateToPage(
                                                  page.link
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "subItemTextWebHeader",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t(page.title))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _c("div", { staticClass: "pl-3 text-muted" }, [
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("sitemap.no_pages_in_section")
                                      )
                                    ),
                                  ]),
                                ]),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.individualPages && _vm.individualPages.length > 0
                        ? _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "h5 font-weight-bold text-menu mb-3",
                                staticStyle: { color: "#495057" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("sitemap.other_features")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pl-3" },
                              _vm._l(_vm.individualPages, function (page) {
                                return _c(
                                  "div",
                                  {
                                    key: page.id || page.title,
                                    staticClass: "mb-1",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "dropdown-item-web-header mb-1 text-decoration-none d-block p-2 rounded",
                                        attrs: { href: page.link },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.navigateToPage(page.link)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "subItemTextWebHeader",
                                          },
                                          [_vm._v(_vm._s(_vm.$t(page.title)))]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.totalAccessiblePages === 0
                        ? _c("div", { staticClass: "text-center mt-5" }, [
                            _c("h5", { staticClass: "text-muted" }, [
                              _vm._v(
                                "\n              Une erreur s'est produite lors du chargement du plan du site.\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-muted" }, [
                              _vm._v(
                                "\n              Veuillez actualiser la page ou contacter l'administrateur.\n            "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }